"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheConcept() {
  const {
    ref: titleRef,
    isVisible: titleVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: para1Ref,
    isVisible: para1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: para2Ref,
    isVisible: para2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="the-concept" className="relative min-h-[30vh] bg-dark-background text-foreground-dark overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541714/img/brushed_steel_texture.png)] bg-cover bg-center opacity-5 pointer-events-none" />

      <div className="relative z-10 container mx-auto px-6 py-16 md:py-24 max-w-4xl">
        {}
        <h2 ref={titleRef} className={`text-4xl md:text-5xl lg:text-6xl font-display font-semibold text-center mb-8 transition-all duration-[var(--duration-medium)] ${titleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
          The Concept
        </h2>

        {}
        <p ref={para1Ref} className={`text-lg md:text-xl leading-relaxed text-center mb-6 text-foreground-dark/90 transition-all duration-[var(--duration-medium)] delay-100 ${para1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
          Prime Laundry is designed as a clean, high-efficiency, self-service
          laundromat concept with a focus on operational discipline, thoughtful
          layout, customer experience, and long-term sustainability.
        </p>

        {}
        <p ref={para2Ref} className={`text-lg md:text-xl leading-relaxed text-center text-foreground-dark/90 transition-all duration-[var(--duration-medium)] delay-200 ${para2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>The vision emphasizes clean, safe, well-lit environments, efficient customer flow, and modern systems intended to support predictable performance and ease of operation.<br /><br />The operating model is designed to support potential future services, such as wash-dry-fold with delivery, where staffing, demand, and operational efficiency align.</p>
      </div>
    </section>;
}